import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "period-label" }
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = { class: "mr-2" }
const _hoisted_4 = { class: "text-right mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: _ctx.menuIsOpen,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.menuIsOpen) = $event)),
    location: "bottom end",
    "close-on-content-click": false,
    "min-width": "260",
    "max-width": "320"
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({
        size: "small",
        variant: "text",
        class: "text-none px-1"
      }, props), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            start: "",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("mdi-clock-outline", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
          _createVNode(_component_v_icon, {
            end: "",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("mdi-menu-down", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, { density: "compact" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (preset, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: index,
                  onClick: ($event: any) => (_ctx.apply(preset))
                }, {
                  prepend: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      (_ctx.isSelected(preset))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            size: "small"
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-check", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(_ctx.labelOf(preset)), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_list_item, { onClick: _ctx.toggleCustom }, {
                prepend: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, [
                    (_ctx.isCustom)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("mdi-check", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                append: _withCtx(() => [
                  _createVNode(_component_v_icon, { size: "small" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.customIsOpen ? 'mdi-menu-up' : 'mdi-menu-down'), 1)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$tt('period.custom')) + " ", 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          (_ctx.customIsOpen)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                class: "pt-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_toggle, {
                    modelValue: _ctx.customMode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customMode) = $event)),
                    mandatory: "",
                    density: "compact",
                    class: "mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        value: "last"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tt('period.mode-last')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        size: "small",
                        value: "since"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$tt('period.mode-since')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.customMode === 'last')
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "4",
                            class: "pr-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                type: "number",
                                min: "1",
                                density: "compact",
                                variant: "outlined",
                                "hide-details": "",
                                label: _ctx.$tt('period.amount'),
                                modelValue: _ctx.customAmount,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customAmount) = $event))
                              }, null, 8, ["label", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                density: "compact",
                                variant: "outlined",
                                "hide-details": "",
                                items: _ctx.unitOptions,
                                "item-title": "text",
                                "item-value": "value",
                                label: _ctx.$tt('period.unit'),
                                modelValue: _ctx.customUnit,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customUnit) = $event))
                              }, null, 8, ["items", "label", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_text_field, {
                        key: 1,
                        type: "date",
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        clearable: "",
                        label: _ctx.$tt('period.mode-since'),
                        modelValue: _ctx.customDate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customDate) = $event))
                      }, null, 8, ["label", "modelValue"])),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      color: "primary",
                      disabled: !_ctx.customIsValid,
                      onClick: _ctx.applyCustom
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tt('period.apply')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}